$(window).on('load', () => {
  if (!$('.section-faq').length) {
    return;
  }

  $('.section-faq-question').click(function() {
    var $parent = $(this).parent();
    var $answer = $(this).next();
    var open = !$parent.hasClass('closed');

    if (open) {
      $parent.addClass('closed');
      $answer.slideUp();
    } else {
      $parent.removeClass('closed');
      $answer.slideDown();
    }
  })
});



// WEBPACK FOOTER //
// ./scripts/blocks/faq.js